module.exports = __webpack_public_path__ + "img/search-gray.2c97b5b3.svg";